import { ReactNode } from 'react';

import { HeroData, HerosData, PageData } from '~/lib/contentful/custom-types';
import { OperatorsHeroTemplate } from '~/old-marketing/components/heros/templates/OperatorsHeroTemplate';
import { WorthlessStudiosHeroTemplate } from '~/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplate';

export type HeroRenderer = (hero: HerosData, additionalProps?: Pick<PageData, 'color'>) => ReactNode;

export const heroRenderer: HeroRenderer = (hero, additionalProps) => {
  if (!hero) return null;

  if (hero.__typename === 'hero') {
    switch ((hero as HeroData).template) {
      case OperatorsHeroTemplate.templateKey:
        return <OperatorsHeroTemplate {...hero} {...additionalProps} key={hero.id} />;
      case WorthlessStudiosHeroTemplate.templateKey:
        return <WorthlessStudiosHeroTemplate {...hero} {...additionalProps} key={hero.id} />;
    }
  }
};
